/* beautiful-react-hooks version: 0.35.0 */
import { slicedToArray as _slicedToArray } from './_virtual/_rollupPluginBabelHelpers.js';
import { useState, useEffect } from 'react';

var asyncGetSystemVoices = function asyncGetSystemVoices() {
  return new Promise(function (resolve) {
    window.speechSynthesis.onvoiceschanged = function () {
      return resolve(window.speechSynthesis.getVoices());
    };

    window.speechSynthesis.getVoices();
  });
};

var useSystemVoices = function useSystemVoices() {
  var _useState = useState([]),
      _useState2 = _slicedToArray(_useState, 2),
      voices = _useState2[0],
      setVoices = _useState2[1];

  useEffect(function () {
    asyncGetSystemVoices().then(setVoices);
  }, []);
  return voices;
};

export default useSystemVoices;
